import { Pipe, PipeTransform } from "@angular/core";
import prettyMs from 'pretty-ms';

@Pipe({
    name: 'formatadorTempo'
})
export class FormatadorTempoPipe implements PipeTransform { 
  constructor() {

  }

  transform(value: number, ...args: any[]) {
    if (value && value > 0) {
      return prettyMs(value * 1000)
    } else {
      return '';
    }
  }
}